import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, Typography, MenuItem, Select, FormControl, InputLabel, FormHelperText } from '@mui/material';
import { useAppContext } from '../AppContext';

const ItemDetails = ({ item, onAddToCart }) => {
  const { t } = useAppContext();
  const [quantity, setQuantity] = useState(1);
  const [selectedVariant, setSelectedVariant] = useState('');
  const [selectedVariantPrice, setSelectedVariantPrice] = useState(0);
  const [variantError, setVariantError] = useState(false);
  const [inscription,setInscription]=useState(false);
  const [inscriptionText,setInscriptionText]=useState('');
  const [inscriptionError,setInscriptionError]=useState(false);

  useEffect(() => {
    // Set default variant if available
    if (item.variants && item.variants.length > 0) {
      setSelectedVariant(item.variants[0].name);
      setSelectedVariantPrice(item.variants[0].price);
    }
    if(item.inscription)
    {
      setInscription(true);
    }
  }, [item]);

  const handleVariantChange = (e) => {
    const variantName = e.target.value;
    setSelectedVariant(variantName);
    setVariantError(false);

    const variant = item.variants.find(v => v.name === variantName);
    if (variant) {
      setSelectedVariantPrice(variant.price);
    }
  };

  const handleInscriptionChange = (e) => {
    const inscriptionText = e.target.value;
    setInscriptionText(inscriptionText);
    if(inscriptionText.length>0){
      setInscriptionError(false);
     
    }
    
  };

  const handleAddToCart = () => {
    if (!selectedVariant && item.variants && item.variants.length > 0) {
      setVariantError(true);
      return;
    }
    if(inscription && inscriptionText.length===0){
      setInscriptionError(true);
      return;
    }
    const {variants,...restOfItem}=item;
    const itemDetails = {
      ...restOfItem,
      quantity,
      selectedVariant,
      variantPrice: selectedVariantPrice,
      totalPrice: (item.price + selectedVariantPrice) * quantity,
      inscription: inscriptionText
    };
    onAddToCart(itemDetails);
  };

  const formatToMyanmarCurrency = (number) => {
    const formattedNumber = new Intl.NumberFormat('my-MM').format(number);
    return `${formattedNumber} MMK`;
  };

  return (
    <Box sx={{ padding: 2, border: '1px solid #ccc', borderRadius: 1 ,marginTop:1}}>
      <Typography variant="h5">{item.name}</Typography>
      <Typography variant="h6" sx={{ mt: 1 }}>
        {t("Variant Price")}: {selectedVariant} - {formatToMyanmarCurrency(item.price + selectedVariantPrice)}
      </Typography>
     
      {item.variants && item.variants.length > 0 && (
        <FormControl fullWidth margin="normal" required error={variantError}>
          <InputLabel id="variant-select-label">{t("Variants")}</InputLabel>
          <Select
            labelId="variant-select-label"
            value={selectedVariant}
            onChange={handleVariantChange}
            label={t("Variant")}
          >
            {item.variants.map((variant, index) => (
              <MenuItem key={index} value={variant.name}>
                {variant.name} - {formatToMyanmarCurrency(item.price+variant.price)}
              </MenuItem>
            ))}
          </Select>
          {variantError && <FormHelperText>{t("Please select a variant.")}</FormHelperText>}
        </FormControl>
      )}
       <TextField
        label={t("Quantity")}
        type="number"
        value={quantity}
        onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value) || 1))}
        fullWidth
        margin="normal"
        inputProps={{ min: 1 }}
      />
         {inscription&&(
       <TextField
       label={t("Inscription")}
       type="text"
       value={inscriptionText}
       onChange={handleInscriptionChange}
       fullWidth
       margin="normal"
       error={inscriptionError}
     />
      )
      }
      
      <Button variant="contained" color="primary" onClick={handleAddToCart} sx={{ mt: 2 }} disableElevation>
        {t("Add")}
      </Button>
    </Box>
  );
};

export default ItemDetails;
